<style lang="css" scoped>

</style>

<template>

  <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on }">
          <v-btn color="error" block @click="dialogDelete()" v-on="on">{{content.delete_switch}}</v-btn>
      </template>
      <v-card>
          <v-card-title class="headline deep-orange lighten-4 red--text text--darken-4" primary-title>{{content.delete_switch}}</v-card-title>
          <v-card-text>
              {{content.delete_val}}
              <br /> {{content.delete_code}} : {{deleteNumber}}
              <v-text-field type="number" v-model="deletecode" :label="content.deleting_code"></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
              <v-btn flat @click="cancel">{{content.cancel}}</v-btn>
              <v-spacer></v-spacer>
              <v-btn :disabled="deletecode != deleteNumber ? true : false" color="red darken-4" dark :flat="deletecode != deleteNumber ? true : false" @click="deleteSwitch()">{{content.agree}}</v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>

</template>

<script>

export default {
    props: ['slug'],
    data() {
        return {
          locale: null,
          dialog: false,
          deleteNumber: null,
          deletecode: null,
        }
    },
    created() {
      this.locale = Lang.get();
      this.setLang();
    },
    methods: {
      deleteSwitch() {
        // this.$emit('detachDevice');
        let data = {
          slug: this.slug,
          action: 'delete',
        }
        this.$store.dispatch('devices/modifyDevice', data);
        this.$router.push("/");
        // detach(){
        //   // this.$emit('modifyItemEvent', data);
        // },
      },
      dialogDelete() {
        this.$emit('toggleSettings', false);
        this.dialog = true;
        this.deletecode = null;
        this.deleteNumber =
            Math.floor(Math.random() * 9) +
            "" +
            Math.floor(Math.random() * 9) +
            "" +
            Math.floor(Math.random() * 9) +
            "" +
            Math.floor(Math.random() * 9);
      },
      cancel(){
        this.dialog = false;
        this.$emit('toggleSettings', true);
      },
      setLang() {
          if (this.locale == "en") {
              this.content = {
                  cancel: 'Cancel',
                  agree: 'Agree',
                  delete_switch: 'Delete Unit',
                  delete_val: 'Are you sure you want to delete the unit?',
                  delete_code: 'The Code for deleing is',
                  deleting_code: 'Type the code',
              };

          } else if (this.locale == "he") {
              this.content = {
                  cancel: 'ביטול',
                  agree: 'מסכים',
                  delete_switch: 'מחק יחידה',
                  delete_val: 'אתה בטוח שברצונך למחוק את היחידה?',
                  delete_code: 'הקוד למחיקה הוא',
                  deleting_code: 'הקלד את הקוד',
              };
          }
      },
    }
}

</script>
